import { Flex, Text, Icon } from '@chakra-ui/react';
import React from 'react';

import { date as commonDate } from '@finley-technologies/common';

import { RDFV } from 'packages/dataPipeline/types/dataPipelineTypes';
import { FiCalendar } from 'react-icons/fi';

export const DateAndVersionInput = ({
  selectedRDFV,
  onClick,
  children,
}: {
  selectedRDFV: RDFV | null;
  onClick: () => void;
  children?: React.ReactNode;
}) => {
  return (
    <Flex
      width="100%"
      borderWidth="1px"
      borderRadius="5px"
      padding="6px 16px"
      minHeight="40px"
      alignItems="center"
      cursor="pointer"
      onClick={onClick}
    >
      <Icon as={FiCalendar} marginRight="10px" h="inherit" />
      {selectedRDFV ? (
        <Text>
          {`${commonDate.fullDateStrToHumanDateString(
            selectedRDFV.reportingDate,
          )}, Version ${selectedRDFV.fileVersion}`}
        </Text>
      ) : (
        <Text>Select Date</Text>
      )}
      {children}
    </Flex>
  );
};
